export default __webpack_public_path__ + "static/media/SAlogo.eaed9245.png";